// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MAM1-","colBig":"styles_colBig__upKAA","colSmall":"styles_colSmall__193yB"};